
<template>
    <header data-elementor-type="header" data-elementor-id="2387" class="elementor elementor-2387 elementor-location-header" data-elementor-post-type="elementor_library">
        <div class="elementor-element elementor-element-47be1ff5 elementor-hidden-tablet elementor-hidden-mobile e-flex e-con-boxed e-con e-parent header-zeleris-bg" data-id="47be1ff5" data-element_type="container" data-settings="{&quot;background_background&quot;:&quot;classic&quot;,&quot;container_type&quot;:&quot;flex&quot;,&quot;content_width&quot;:&quot;boxed&quot;}" data-core-v316-plus="true">
            <div class="e-con-inner header-inner-container">
                <div class="elementor-element elementor-element-14b78cf3 e-con-full e-flex e-con e-child" data-id="14b78cf3" data-element_type="container" data-settings="{&quot;content_width&quot;:&quot;full&quot;,&quot;container_type&quot;:&quot;flex&quot;}">
                    <div class="elementor-element elementor-element-f3cb7 elementor-widget elementor-widget-image" data-id="f3cb7" data-element_type="widget" data-widget_type="image.default">
                        <div class="elementor-widget-container">
                            <a href="https://www.zeleris.com" class="logo-link">
                                <img src="https://www.zeleris.com/wp-content/uploads/2023/12/LOGO-HORIZONTAL.svg" title="logotipo-zeleris" alt="logotipo-zeleris" loading="lazy" class="logo-zeleris-img" />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <nav id="main_nav">
            <p class="nav_sections"></p>
        </nav>
    </header>
</template>

<script>
    export default {
        computed: {
            esMovil() { return this.$vuetify.breakpoint.smAndDown }
        }
    }
</script>

<style scoped>
    html {
        font-size: 62.5% !important;
    }

    /* 1. Contenedor del fondo negro: fijar la altura exacta como en la web original */
    .header-zeleris-bg {
        background-color: #212121 !important; /* Color negro/gris oscuro original */
        min-height: 80px !important;
        height: 80px !important;
        padding: 0 10% !important; /* Espaciado lateral id�ntico al de zeleris.com */
        display: flex !important;
        align-items: center !important;
        justify-content: flex-start !important;
        box-sizing: border-box !important;
    }

    /* 2. Estructura interna */
    .header-inner-container {
        width: 100% !important;
        max-width: 1200px !important; /* Ancho m�ximo para mantener alineado el margen izquierdo */
        display: flex !important;
        align-items: center !important;
        justify-content: flex-start !important;
        margin: 0 !important;
        padding: 0 !important;
    }

    .elementor-widget-image {
        width: auto !important;
        max-width: fit-content !important;
        display: flex !important;
        align-items: center !important;
        margin: 0 !important;
    }

    .elementor-widget-container {
        width: auto !important;
        display: flex !important;
        align-items: center !important;
    }

    .logo-link {
        display: inline-flex !important;
        align-items: center !important;
        line-height: 0;
    }

    /* 3. Tama�o ajustado de la imagen */
    .logo-zeleris-img {
        width: 180px !important;
        height: auto !important;
        max-height: 44px !important;
        display: block !important;
        object-fit: contain !important;
    }
</style>